module.exports = __webpack_public_path__ + "img/safety.08307e84.png";